function h(r, a) {
  var s = 0,
    u = 1e3 / a,
    e,
    t;
  var n = function n(l) {
    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
    s = o, e = null, t && (clearTimeout(t), t = null), r.apply(null, l);
  };
  return [function () {
    var o = Date.now(),
      i = o - s;
    for (var _len = arguments.length, l = new Array(_len), _key = 0; _key < _len; _key++) {
      l[_key] = arguments[_key];
    }
    i >= u ? n(l, o) : (e = l, t || (t = setTimeout(function () {
      t = null, n(e);
    }, u - i)));
  }, function () {
    return e && n(e);
  }];
}
export { h as default };
